import {
  getListByDepartIdMenu,
  getListBySetStatusMenu,
  deleteMenu,
  // getMenu,
  addMenu,
  editMenu,
  setHideMenu,
  cancelIndexMenu,
  setSortMenu,
  setIndexMenu,
  copyMenu,
  getListByTypeResource
} from '../../api/usermanage'
import {
  formatTreeData
} from '../../utils/utils'
export default {
  state: {
    options: {},
    highNodes: [],
    menuList: [],
    menuResource: []
  },
  mutations: {
    SET_LISTMENU: (state, list) => {
      state.menuList = list
    },
    SET_HIGHNODES: (state, list) => {
      state.highNodes = list
    },
    SET_OPTSMENU: (state, data) => {
      state.options = data
    },
    SET_MENURESOURCE: (state, data) => {
      state.menuResource = data
    }
  },
  actions: {
    GetMenuResource({ commit }) {
      return new Promise(resolve => {
        getListByTypeResource({ type: 'Menu' }).then(res => {
          commit('SET_MENURESOURCE', res.data)
        })
      })
    },
    CopyMenu({ commit }, data) {
      return new Promise(resolve => {
        copyMenu(data).then(res => {
          resolve(res.data)
        })
      })
    },
    IndexMenu({ commit }, data) {
      return new Promise(resolve => {
        if (data.isIndex) {
          setIndexMenu(data).then(res => {
            resolve({ msg: '设置成功' })
          })
        } else {
          cancelIndexMenu(data).then(res => {
            resolve({ msg: '取消成功' })
          })
        }
      })
    },
    SortMenu({ commit }, data) {
      return new Promise(resolve => {
        setSortMenu(data).then(res => {
          resolve(res.data)
        })
      })
    },
    HideMenu({ commit }, data) {
      return new Promise(resolve => {
        setHideMenu(data).then(res => {
          resolve(res.data)
        })
      })
    },
    UpdateMenu({ commit }, data) {
      return new Promise(resolve => {
        editMenu(data).then(res => {
          resolve(res.data)
        })
      })
    },
    AddMenu({ commit, dispatch }, data) {
      return new Promise(resolve => {
        addMenu(data).then(res => {
          resolve(res.data)
        })
      })
    },
    // 获取菜单
    GetListMenu({ commit }, data) {
      return new Promise(resolve => {
        getListByDepartIdMenu(data).then(res => {
          resolve(formatTreeData(res.data || []))
        })
      })
    },
    // 获取最高节点菜单
    GetHightDepartMenu({ commit }, data) {
      return new Promise(resolve => {
        getListBySetStatusMenu(data).then(res => {
          resolve(res.data)
        })
      })
    },
    // 删除菜单
    DeleteMenu({ commit }, data) {
      return new Promise(resolve => {
        deleteMenu(data).then(res => {
          resolve(res.data)
        })
      })
    }
  }
}
